import { useQuery } from '@apollo/client';
import { QUERY } from '../gql-operations';

/**
 * Returns max file size and remaining account storage for upload validation.
 * Effective limit for a single file = min(maxFileSize, remainingStorage).
 */
function useGetMaxFileSize() {
    const { data } = useQuery(QUERY.ME, {
        fetchPolicy: 'network-only'
    });
    let user_max_file_size;
    let remaining_storage; // maxStorage - totalStorage; undefined if unknown
    if (data && data.me && data.me.quota) {
        const q = data.me.quota;
        user_max_file_size = q.maxFileSize;
        const maxStorage = typeof q.maxStorage === 'number' ? q.maxStorage : Number(q.maxStorage);
        const totalStorage = typeof q.totalStorage === 'number' ? q.totalStorage : Number(q.totalStorage);
        if (maxStorage > 0) {
            remaining_storage = Math.max(0, maxStorage - totalStorage);
        }
    }
    return { user_max_file_size, remaining_storage };
}

export default useGetMaxFileSize;
